import axios from "axios";
import { IAPIResult } from "models/interfaces";

export async function entryAddress(postNo1: string, postNo2: string, token: string) {
  const response = await axios.post<
    IAPIResult<{
      prefecture_cd: string;
      address: string;
    }>
  >(
    "/api.d/v1/entry/address/search",
    { 
      post_no1: postNo1 ,
      post_no2: postNo2
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}

export async function address(postNo1: string, postNo2: string) {
  const response = await axios.post<
    IAPIResult<{
      prefecture_cd: string;
      address: string;
    }>
  >("/api.d/v1/ec/address/search", { post_no1: postNo1, post_no2: postNo2 });
  return response.data;
}
